var App = App || {};

App.WidgetForm = (function ($) {
    'use strict';

    function Init(selector) {
        const form = selector.find("form");

        // Make file uploader "delete file" link keyboard accessible
        form
            .find(".ktc-uploader-text-button")
            .attr("href", "#")
            .on("click", function (e) { e.preventDefault(); });

        // If the form has been modified for custom validation, send it that way
        if (form.is("[data-zag-validate-form]")) {
            App.SharedFormValidation.Init(form);
        }

        // Custom handler for "Make An Appointment" form
        HandleAppointmentFormButtons(form);
    }

    function HandleAppointmentFormButtons(form) {
        // Check if this is the "Make An Appointment" form
        const formAction = form.attr('action');
        if (!formAction || formAction.toLowerCase().indexOf('makeanappointment') === -1) {
            return;
        }

        // Find the Location dropdown
        const locationDropdown = form.find('select[name$=".Location.SelectedValue"]');
        if (locationDropdown.length === 0) {
            return;
        }

        // Find the Submit button
        const defaultSubmitBtn = form.find('button[type="submit"], input[type="submit"]').first();
        if (defaultSubmitBtn.length === 0) {
            return;
        }

        // Create an alternative Submit button that triggers the Engageware appointment scheduler
        let alternativeBtn = form.find('.alternative-submit-btn');
        if (alternativeBtn.length === 0) {
            alternativeBtn = $('<a href="#" target="_blank" class="btn btn-primary align-self-center alternative-submit-btn" style="display: none;" onclick="return tt.launchWorkflow(this);">Submit</a>');
            defaultSubmitBtn.parent().append(alternativeBtn);
        }

        // Determine which Submit button to display based on the selected location
        function toggleButtons() {
            const selectedValue = locationDropdown.val();

            if (selectedValue === 'auburnbranch@web5.com:Auburn') {
                // Get the location name to use as the value of the locationId parameter
                const locationId = selectedValue.split(':')[1];

                // Get values from form fields
                const firstName = form.find('input[name$=".FirstName.Value"]').val() || '';
                const lastName = form.find('input[name$=".LastName.Value"]').val() || '';
                const email = form.find('input[name$=".Email.Value"]').val() || '';
                const customer = form.find('input[name$=".Customer.SelectedValue"]:checked').val() || '';

                // Build the URL with query string parameters
                const baseUrl = `https://www04.timetrade.com/app/web5/workflows/wf001/schedule?locationId=${encodeURIComponent(locationId)}`;
                const params = [
                    `attendee_person_firstName=${encodeURIComponent(firstName)}`,
                    `attendee_person_lastName=${encodeURIComponent(lastName)}`,
                    `attendee_email=${encodeURIComponent(email)}`,
                    `attendee_customField0=${encodeURIComponent(customer)}`
                ];
                const fullUrl = `${baseUrl}&${params.join('&')}`;

                alternativeBtn.attr('href', fullUrl);

                defaultSubmitBtn.hide();
                alternativeBtn.show();
            } else {
                defaultSubmitBtn.show();
                alternativeBtn.hide();
            }
        }

        // Initial setup
        toggleButtons();

        // Update buttons when Location dropdown changes
        locationDropdown.on('change', toggleButtons);

        // Update URL parameters when form field values change
        form.find('input[name$=".FirstName.Value"]').on('input', toggleButtons);
        form.find('input[name$=".LastName.Value"]').on('input', toggleButtons);
        form.find('input[name$=".Email.Value"]').on('input', toggleButtons);
        form.find('input[name$=".Customer.SelectedValue"]').on('change', toggleButtons);
    }

    return {
        Init: Init
    };

})(jQuery);